<template>
  <div class="discpiption-random-tag-refer">
    <div
      class="discpiption-random-tag-refer-tags"
      ref="refContainer"
    >
      <swiper
        ref="refStyleSwiper"
        slidesPerView="auto"
        :allow-slide-next="false"
        :allow-slide-prev="false"
        :spaceBetween="createRenderType == 'pc' ? 8 : 8"
        :slidesOffsetAfter="createRenderType == 'pc' ? 8 : 8"
        @slideChange="onSlideChange"
      >
        <swiper-slide>
          <div class="swiper-tag-item-random">
            <IconButton
              :disabled="props.disabled"
              :loading="props.loading"
              size="28px"
              icoSize="16px"
              backgroundColor="rgb(255, 255, 255, 0.1)"
              hoverBackgroundColor="rgb(255, 255, 255, 0.2)"
              @onClick="onRandomClick"
            >
              <img src="@/assets/img/dice-random-ico.png" />
            </IconButton>
          </div>
        </swiper-slide>
        <swiper-slide
          v-for="(item, index) in renderData.randomTags"
          :key="index + 1"
        >
          <div
            class="swiper-tag-item pointer"
            @click="
              () => {
                addMusicDiscribe(item, index);
              }
            "
          >
            <span class="block omlh-2 tc"> {{ item.content }}</span>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import { useRouter, useRoute } from "vue-router";
import { $$t, $$language } from "@/i18n/i18n.js";

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/effect-coverflow";
import IconButton from "@/components/basic/button/IconButton.vue";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import apiReferMusic from "@/api/api/apiReferMusic.js";
import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();

const { createRenderType } = storeToRefs(createLayoutStore);

const Router = useRouter();
const route = useRoute();

const refStyleSwiper = ref(null);
const refContainer = ref(null);
const props = defineProps({
  randomTags: {
    type: Array,
    default: () => {
      return [];
    },
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits(["randomClick"]);

const stateData = {
  observeFirst: null,
  observeLast: null,
};

const renderData = reactive({
  randomTags: [],
  swiperActiveIndex: 0,
  disabledSwichFirst: false,
  disabledSwichLast: false,
  styleList: new Array(10).fill(1),
  randomTagVibility: true,
});

const onSlideChange = (swiper) => {
  renderData.swiperActiveIndex = swiper.activeIndex;
};

const changePrev = () => {
  refStyleSwiper.value?.$el.swiper?.slideTo(renderData.swiperActiveIndex - 3);
};

const changeNext = () => {
  refStyleSwiper.value?.$el.swiper?.slideTo(renderData.swiperActiveIndex + 3);
};

const initObserverEvent = () => {
  nextTick(() => {
    if (refStyleSwiper.value?.$el) {
      setTimeout(() => {
        let els = refStyleSwiper.value?.$el.querySelectorAll(".swiper-slide");
        if (els && els.length > 1) {
          isElementHalfVisible(els[0], "First");
          isElementHalfVisible(els[props.tagList.length - 1], "Last");
        }
      }, 10);
    }
  });
};

const isElementHalfVisible = (element, type) => {
  stateData[`observe${type}`] = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      renderData[`disabledSwich${type}`] = entry.isIntersecting;
    });
  });
  stateData[`observe${type}`].observe(element);
};

const onRandomClick = () => {
  emits("randomClick");
};

const addMusicDiscribe = (item, index) => {
  emits("addMusicDiscribe", item, index);
};

const checkIfOverflow = (containerEl, childSelector) => {
  return new Promise((resolve, reject) => {
    const children = containerEl.querySelectorAll(childSelector);

    const containerWidth = containerEl.offsetWidth;

    let totalWidth = 0;
    let maxIndex = 0;
    children.forEach((child, index) => {
      const style = getComputedStyle(child);
      totalWidth +=
        child.offsetWidth +
        parseFloat(style.marginLeft) +
        parseFloat(style.marginRight);
        if (totalWidth > containerWidth) {
          child.classList.add("swiper-slide-hide");
        }else{
          maxIndex = index;
        }
    });
    resolve(maxIndex);
  });
};

const initObserverViewEvent = () => {
  renderData.randomTagVibility = false;
  nextTick(() => {
    checkIfOverflow(refContainer.value, ".swiper-slide")
      .then((index) => {
        renderData.randomTagVibility = false;
      })
      .catch((error) => {
        renderData.randomTagVibility = false;
      });
  });
};

watch(
  () => {
    return props.randomTags;
  },
  () => {
    renderData.randomTags = props.randomTags.filter((item) => item.show);
    initObserverViewEvent();
  }
);

onMounted(() => {
  renderData.randomTags = props.randomTags.filter((item) => item.show);
  initObserverViewEvent();
});

onUnmounted(() => {
  // stateData[`observeFirst`]?.disconnect();
  // stateData[`observeLast`]?.disconnect();
});
</script>
<style lang="scss">
.discpiption-random-tag-refer {
  .discpiption-random-tag-refer-tags {
    height: 28px;
    .swiper-tag-item-random {
      .icon-button {
        width: 40px !important;
      }
    }
    .swiper-tag-item {
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: 28px;
      text-align: center;
      color: #ffffff;
      height: 28px;
      border-radius: 50px;
      padding: 0;
      background: rgba(255, 255, 255, 0.1);
      padding: 0 12px;
      &:hover {
        background: rgba(255, 255, 255, 0.2);
      }

      &.swiper-tag-item-active {
        opacity: 0.5;
        pointer-events: none;
      }
    }
    .swiper {
      height: 100%;
      .swiper-wrapper {
        display: flex;
        height: 100%;
      }
      .swiper-slide {
        height: 100%;
        width: max-content;
        &.swiper-slide-hide {
          display: none;
        }
      }
    }
  }
}
</style>
